import React from 'react';
import Carousel from '../components/Carousel';
import PromoModal from '../components/PromoModal';
import { usePromoModal } from '../hooks/usePromoModal';
import { SEOHead } from '../components/SEOHead';
import { HomePageContainer, HeroContainer, VisuallyHiddenH1 } from './HomePage.styled';

function HomePage() {
    const { isOpen, config, closeModal } = usePromoModal();

    return (
        <HomePageContainer>
            <SEOHead
                title="Duo a Color - Diseño Artesanal Punch Needle"
                description="Duo a Color (duoacolor) crea diseños únicos con punch needle y pintura personalizada. Totebags, cojines y más. Arte textil artesanal hecho en España."
                path="/"
            />
            <HeroContainer>
                <VisuallyHiddenH1>Duo a Color - Diseño Artesanal Punch Needle España</VisuallyHiddenH1>
                <Carousel />
            </HeroContainer>

            <PromoModal
                isOpen={isOpen}
                onClose={closeModal}
                config={config}
            />
        </HomePageContainer>
    );
}

export default HomePage;